import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstanceg4mecbw0mfx8 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation, requestUuid, data, errors, extensions, exception) {
        return new.target.u41(operation, requestUuid, data, errors, extensions, exception);
      }
      static u41(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.m41_1 = operation;
        $this.n41_1 = requestUuid;
        $this.o41_1 = data;
        $this.p41_1 = errors;
        $this.q41_1 = extensions;
        $this.r41_1 = exception;
        $this.s41_1 = Companion_getInstance().c40_1;
        $this.t41_1 = false;
        return $this;
      }
      static v41(operation, requestUuid) {
        return this.u41(operation, requestUuid, null, null, null, null);
      }
      w41(executionContext) {
        // Inline function 'kotlin.apply' call
        this.s41_1 = this.s41_1.x41(executionContext);
        return this;
      }
      y41(data) {
        // Inline function 'kotlin.apply' call
        this.o41_1 = data;
        return this;
      }
      z41(errors) {
        // Inline function 'kotlin.apply' call
        this.p41_1 = errors;
        return this;
      }
      a42(exception) {
        // Inline function 'kotlin.apply' call
        this.r41_1 = exception;
        return this;
      }
      s40(extensions) {
        // Inline function 'kotlin.apply' call
        this.q41_1 = extensions;
        return this;
      }
      d40(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.n41_1 = requestUuid;
        return this;
      }
      b42(isLast) {
        // Inline function 'kotlin.apply' call
        this.t41_1 = isLast;
        return this;
      }
      j37() {
        var tmp1_operation = this.m41_1;
        var tmp2_requestUuid = this.n41_1;
        var tmp3_data = this.o41_1;
        var tmp4_executionContext = this.s41_1;
        var tmp0_elvis_lhs = this.q41_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.p41_1;
        var tmp7_exception = this.r41_1;
        var tmp8_isLast = this.t41_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.c42_1 = requestUuid;
        this.d42_1 = operation;
        this.e42_1 = data;
        this.f42_1 = errors;
        this.g42_1 = exception;
        this.h42_1 = extensions;
        this.i42_1 = executionContext;
        this.j42_1 = isLast;
      }
      k42() {
        var tmp;
        if (this.y42()) {
          throw ApolloGraphQLException().x42(first(ensureNotNull(this.f42_1)));
        } else if (!(this.g42_1 == null)) {
          throw DefaultApolloException().q42('An exception happened', this.g42_1);
        } else {
          tmp = this.l42();
        }
        return tmp;
      }
      l42() {
        var tmp0_elvis_lhs = this.e42_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().d43(this.g42_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      y42() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.f42_1;
        return !(this_0 == null || this_0.n1());
      }
      k41() {
        return Builder().u41(this.d42_1, this.c42_1, this.e42_1, this.f42_1, this.h42_1, this.g42_1).w41(this.i42_1).b42(this.j42_1);
      }
      toString() {
        var tmp = 'operationName=' + this.d42_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.e42_1 == null ? 'null' : this.d42_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.f42_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.g42_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.g42_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
